//initial redux
import { put, call, takeEvery, fork, all, take } from "redux-saga/effects";
import importStatusService from "../../../services/importStatus";

const initialState = {
	isBusy: false,
	importStatus: null,
	showStackTrace: false,
};

/////////
//types
export const types = {
	GET_DATA: "screens/MasterRules/Import/Status/GET_DATA",
	ON_DATA_RETURNED: "screens/MasterRules/Import/Status/ON_DATA_RETURNED",
};

///////////
//reducers
export const reducers = {
	reducer(state = initialState, action) {
		switch (action.type) {
			case types.GET_DATA:
				return { ...state, isBusy: true };
			case types.ON_DATA_RETURNED:
				return { ...state, importStatus: action.payload.importStatus, isBusy: false };
			default:
				return state;
		}
	}
};

//////////
//sagas
export const sagas = {
	*rootSaga() {
		yield all([
			this.getData(),
		]);
	},

	*getData() {

		yield takeEvery(types.GET_DATA, function*({ payload }) {

			let importStatus = yield call(
				importStatusService.getImportStatus,
				payload.id);

			yield put(actions.onDataReturned(importStatus));

		});
	},

};

////////
//actions
export const actions = {

	getData(id) {

		return {
			type: types.GET_DATA,
			payload: {
				id
			}
		};
	},

	onDataReturned(importStatus) {

		return {
			type: types.ON_DATA_RETURNED,
			payload: {
				importStatus
			}
		}
	},

};



// WEBPACK FOOTER //
// ./src/ui/ImportOverview/ImportStatus/redux.js